import React from "react";
import { observer } from "mobx-react-lite";
import { useCreateLeagueMatchStore } from "../../../store/StoreContext";
import {
  convertTo12HourFormatTimeRange,
  removeTrailZerosInTime,
} from "../../../utils/utils";
import { Colors } from "../../../utils/colors";
import { TCText } from "../../../components/tcText/TCText";
import { SpecificBookingSlot } from "../../../apis/types";

type Props = {};

export const SelectTimeSlot: React.FC<Props> = observer(() => {
  const createLeagueMatchStore = useCreateLeagueMatchStore();

  const TimeSlotButton: React.FC<{
    slotName: string;
    isSelected?: boolean;
    onClick: () => void;
    isAvailable: boolean;
  }> = ({ slotName, isSelected, onClick, isAvailable }) => {
    const timeFormat = slotName.split(" ")[1];
    const timeSlot = convertTo12HourFormatTimeRange(slotName.split(" ")[0]);

    return (
      <div
        onClick={isAvailable ? onClick : () => {}}
        style={{
          // padding: "8px 16px",
          borderRadius: 12,
          border:
            isSelected || !isAvailable
              ? `0px solid ${Colors.lightGreyBackground}`
              : `2px solid ${Colors.lightGreyBackground}`,
          backgroundColor: !isAvailable
            ? "#E7E6E6"
            : isSelected
            ? Colors.gold
            : "white",
          cursor: "pointer",
          width: 106,
          height: 36,
          textAlign: "center",
          justifyContent: "center",
          alignItems: "center",
          display: "flex",
        }}>
        <TCText
          value={`${removeTrailZerosInTime(timeSlot)}`}
          style={{
            fontSize: 12,
            color: !isAvailable
              ? Colors.grey
              : isSelected
              ? "white"
              : Colors.green,
          }}
        />
        <TCText
          value={`${timeFormat}`}
          style={{
            fontSize: 8,
            color: !isAvailable
              ? Colors.grey
              : isSelected
              ? "white"
              : Colors.green,
            marginTop: -2,
            marginLeft: 3,
          }}
        />
      </div>
    );
  };

  return createLeagueMatchStore.timeSlots.length ? (
    <div style={{ padding: "16px 0" }}>
      <TCText
        value="Select time"
        style={{
          fontSize: 12,
          fontWeight: 500,
          marginBottom: 16,
        }}
      />
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(106px, 1fr))",
          gap: 12,
        }}>
        {createLeagueMatchStore.timeSlots.map(
          (slot: SpecificBookingSlot, index) => (
            <TimeSlotButton
              key={index}
              slotName={slot.slotName}
              isSelected={createLeagueMatchStore.selectedTimeSlots.includes(
                slot
              )}
              onClick={() => createLeagueMatchStore.setSelectedTimeSlot(slot)}
              isAvailable={slot.isAvailable}
            />
          )
        )}
      </div>
    </div>
  ) : (
    <TCText
      style={{
        textAlign: "center",
        marginTop: 20,
        fontSize: 14,
        color: Colors.black,
      }}
      value="No time slots found"
    />
  );
});
